<template>
  <div class="section group">
    <b-card no-body>
      <b-tabs pills card vertical>
        <b-tab title-item-class="mytab" :title="$t('changePassword')" :active="true">
          <b-card-text><ChangePassword /></b-card-text>
        </b-tab>
		<b-tab title-item-class="mytab" :title="$t('2FA')" :active="true">
          <b-card-text>
			<Toggle2FA />
			<p>{{ $t('2FADisclaimer') }}</p>
		</b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import ChangePassword from '../components/common/ChangePassword'
import Toggle2FA from '../components/common/Toggle2FA.vue'


export default {
  metaInfo() {
    return {
      title: this.$i18n.t('settings'),
    }
  },
  components: {
    ChangePassword,
	Toggle2FA
  }
}
</script>

<style lang="css">
 .nav-pills .mytab .nav-link:not(.active) {
    background-color: var(--primaryDark) !important;
  }

  .nav-pills .mytab .nav-link {
    background-color: var(--primaryDark) !important;
	color: var(--bright) !important;
	margin-bottom: 10px;
  }

  .tab-content > .tab-pane {
    border: 1px solid;
    border-left: 0px none;
  }
  .nav-pills .mytab .nav-link:hover {
    color: var(--bg) !important;
	background-color: var(--primarySuperLight) !important;
  }
  .tab-content > .tab-pane {
    border: none;
  }

  @media only screen and (max-width: 480px) {
 .nav-pills .mytab {
  width: 100%;
}
.tabs > .col-auto {
  width: 100%;
}
  }
</style>